import { t } from "i18next"
import React from "react"

interface RoleProps {
  x?: number
  y?: number
  width?: number
  height?: number
}

const Role = ({ x = 0, y = 0, width = 130, height = 470 }: RoleProps): React.JSX.Element => {
  const description = t("alert.onlyParticipants")
  const fontSize = 10
  const maxTextWidth = (width * 0.85) - 15 // até a linha divisória (85% da largura)
  const approxCharWidth = fontSize * 0.55
  const maxChars = Math.floor(maxTextWidth / approxCharWidth)
  const isTruncated = description.length > maxChars
  const displayDescription = isTruncated ? `${description.slice(0, Math.max(0, maxChars - 1))}…` : description

  const lineLength = width * 0.85

  return (
    <g>
      <rect
        id="roles"
        className="quandrant droppable-target"
        x={x}
        y={y}
        width={width}
        height={height}
        fill="white"
        stroke="silver"
        strokeWidth="1"
        rx="6"
        ry="6"
      ></rect>
      <text fill="black" x={x + 15} y={y + 30} style={{ fontSize: "16px" }}>
        {t("board.title.roles")}
      </text>
      <line x1={x} x2={x + lineLength} y1={y + 60} y2={y + 60} stroke="#E5E5E5" strokeWidth="1"></line>
      <text fill="gray" x={x + 15} y={y + 45} textAnchor="start" dominantBaseline="middle" style={{ fontSize: "10px" }}>
        {displayDescription}
        {isTruncated && <title>{description}</title>}
      </text>
    </g>
  )
}

export default Role
